// This is for private multi-tenant setup only!
// It allows saving tenant-specific data to the Redux store on server.
// The data is then passed to frontend among preloaded state.

import { createSlice } from '@reduxjs/toolkit';

// ================ Redux Toolkit Slice ================ //

const tenantSlice = createSlice({
  name: 'tenant',
  initialState: {
    clientId: null,
    marketplaceName: null,
    marketplaceRootURL: null,
    stripePublishableKey: null,
    facebookClientId: null,
    googleClientId: null,
  },
  reducers: {
    storeData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// ================ Exports ================ //

export const { storeData } = tenantSlice.actions;
export default tenantSlice.reducer;
